import React from 'react';

import styled from 'styled-components';

import v from '../../styles/Variables';

interface Props {
  delimiter: string;
  delimiterClose: string;
  key: string;
  item: {
    content: string;
    isOpen: boolean;
    title: string;
  };
  i: number;
  togglePanels: (i: number) => void;
}

const AccordionItem = ({ delimiter = '+', delimiterClose = '-', item, i, togglePanels }: Props) => {
  return (
    <div data-test="component-accordion-item" className="nwc--accordion-item">
      <AccordionItemStyle className="nwc--accordion-title padding--sm cursor--pointer" onClick={() => togglePanels(i)}>
        <span data-test="component-accordion-delimiter" className="nwc--accordion-delimiter float--right font--16">
          {item.isOpen === true ? delimiterClose : delimiter}
          &nbsp;&nbsp;
        </span>
        {item.title}
      </AccordionItemStyle>
      <ContentStyle className={item.isOpen === true ? 'nwc--accordion-content' : 'nwc--accordion-content hide'}>{item.content}</ContentStyle>
    </div>
  );
};

export default AccordionItem;

/* styles */
const AccordionItemStyle = styled.button`
  display: block;
  margin: 0;
  width: 100%;
  text-align: left;
  border: none;
  background: none;
  padding: 8px;
  font-size: 21px;
  color: ${v.colors.dark};
  border-bottom: 1px solid ${v.colors.border};
`;

const ContentStyle = styled.div`
  padding: 8px;
  font-size: 14px;
`;
